import { HANDLE_JOB_CARD, SET_DEFAULT_JOB_CARD, RESET } from '../actions';
import moment from "moment";

const initialState = {  
    customerName: "",
    phone: [""],
    t_phone: null,
    follow_up_date: null,
    area: "",
    city: "",
    state: "",
    landmark: "",
    addressType: "",
    pincode: "",
    latitude: 11.3806,
    longitude: 77.8944,
    longitudeDelta: 0.015,
    latitudeDelta: 0.0121,
    addressString: "",
    scrollMap: false,
    fetchLocation: true,
    natureofProblem: "",
    work_type: "",
    servicePerson: "",
    jobCard: [],
    jobcard_number: "",
    edit: false,
    view: false,
    id: "",

    searchText: "",
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
    field: "14",
    status: [4],
    verificationstatus: 1,
    customerSearchText: "",
    selectedCustomer: null,
    customerData: [],
    filterApplied: true,

    toggleTable: true,
    products: [],

    dateFilter: "Today",
    workTypeFilter: [1,2,8,3],
    // workTypeFilter: [1,2,3,4,5,6],
    customer: {},

    documentation: [""]
};

export default function(state = initialState, action) {
  switch (action.type) {
    case HANDLE_JOB_CARD:
      console.log(action);
      return {
        ...state,
        ...action.data
      };
    case SET_DEFAULT_JOB_CARD:
        return {
            ...state,
            customerName: "",
            phone: [""],
            t_phone: null,
            follow_up_date: null,
            area: "",
            city: "",
            state: "",
            landmark: "",
            addressType: "",
            pincode: "",
            latitude: 11.3806,
            longitude: 77.8944,
            longitudeDelta: 0.015,
            latitudeDelta: 0.0121,
            addressString: "",
            scrollMap: false,
            fetchLocation: true,
            natureofProblem: "",
            servicePerson: "",
            edit: false,
            jobcard_number: "",
            view: false,
            id: "",
            work_type: "",
            products: [],
            dateFilter: "Today",
            // workTypeFilter: [1,2,3,4,5,6],
            workTypeFilter: [1,2,8],
            startDate: moment().format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),

            documentation: [""]
        };
    case RESET:
        return initialState;
    default:
      return state;
  } 
}
